import styled from 'styled-components';

export const CarouselWrapper = styled.div<{
  width?: string | null | undefined;
}>`
  display: flex;
  flex-flow: column;
  width: ${({ width }) => width || '100%'};
  gap: ${({ theme }) => theme.spacing.xl};
  margin-top: ${({ theme }) => theme.spacing['2Xl']};
`;

export const CarouselContentContainer = styled.div`
  // For mobile we do not need to stretch the content
  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    width: 100%;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-flow: row;
  scroll-snap-type: x mandatory;
  overflow: hidden;
  gap: ${({ theme }) => theme.spacing.xl};

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
`;

export const Content = styled.div`
  scroll-snap-align: start;
  position: relative;

  padding: 2px;
  margin: 2px;
  display: flex;
  justify-content: center;
  align-items: stretch;

  &.active {
    scroll-snap-type: unset;
  }
`;

export const NavigationContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
`;

export const Arrow = styled.div`
  width: ${({ theme }) => theme.fontSize[300]};
  height: ${({ theme }) => theme.fontSize[300]};
`;
